import React, { FC, useEffect } from 'react';
import { LandscapeUpdatesTemplate } from '../../templates';
import styles from './LandscapeUpdatesPage.module.css';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import {
  deleteStory,
  fetchStoriesByCompactId,
} from '../../../store/landscapeAPI/story/reducers/story.slice';

interface LandscapeUpdatesPageProps {}

const LandscapeUpdatesPage: FC<LandscapeUpdatesPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const navigate = useNavigate();

  const { filteredStories: stories } = useSelector(
    (state: RootState) => state.storySlice
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchStoriesByCompactId(id));
    }
  }, [dispatch, id]);

  const handleEdit = (storyId: string) => {
    navigate(`/landscapes/edit/${id}/updates/story/edit/${storyId}`);
  };
  const handleDelete = async (storyId: string) => {
    if (id) {
      await dispatch(deleteStory({ existingId: storyId, compactId: id }));
    }
  };

  return (
    <div className={cn(styles.landscapeUpdatesWrapper)}>
      <LandscapeUpdatesTemplate
        stories={stories ?? []}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
    </div>
  );
};

export default LandscapeUpdatesPage;
